<template>
  <transition name="overlay">
    <div v-if="state.isVisible" class="overlay" @click="close"></div>
  </transition>
</template>

<script setup>
import { useSharedState } from '@composables/use-shared-state';

const { state } = useSharedState({ id: 'overlay' });
state.isVisible = false;

const close = () => {
  state.isVisible = false;
};
</script>
